module.exports = __webpack_public_path__ + "static/media/icon-next.72f86f41.svg";